// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".payment-div[data-v-3d2e2f26]{position:sticky;bottom:0;z-index:10;background:hsla(0,0%,100%,.8);-webkit-backdrop-filter:blur(5px);backdrop-filter:blur(5px);border-radius:8px}.min-h-unset[data-v-3d2e2f26]{min-height:unset}.rotate-180[data-v-3d2e2f26]{-webkit-transition:all .25s ease-out;transition:all .25s ease-out;-webkit-transform:rotate(-180deg);transform:rotate(-180deg)}", ""]);
// Exports
module.exports = exports;
